let reloading = false;

export function markAppReloading() {
    reloading = true;
}

export function isAppReloading() {
    return reloading;
}
